<template>
  <v-container grid-list-md pa-0 ma-2 style="max-width: calc(100% - 16px)">
    <v-layout row wrap fill-height>
      <!-- Credores -->
      <v-flex xs12 md5 lg4>
        <div
          :style="
            $vuetify.breakpoint.smAndDown
              ? ''
              : 'position: sticky; top: 12px;height: calc(100vh - 20px)'
          "
        >
          <v-subheader>Credores</v-subheader>
          <v-list
            class="py-0"
            style="overflow-y: auto"
            :style="
              $vuetify.breakpoint.smAndDown
                ? 'height: 300px;'
                : 'height: calc(100% - 48px);'
            "
          >
            <v-list-tile
              class="pa-0"
              :key="credito.creditor_id"
              v-for="credito in creditos"
            >
              <v-list-tile-content>
                <v-list-tile-title>
                  #{{ credito.creditor_id }} - {{ credito.name }}
                </v-list-tile-title>
              </v-list-tile-content>
              <v-list-tile-action>
                <v-select
                  single-line
                  hide-details
                  item-value="id"
                  item-text="name"
                  class="ma-0 pa-0"
                  style="width: 200px"
                  :items="poolsValidated"
                  @change="activePool(credito.creditor_id, credito.sms_gateway_pool.id)"
                  v-model="credito.sms_gateway_pool.id"
                ></v-select>
              </v-list-tile-action>
            </v-list-tile>
          </v-list>
        </div>
      </v-flex>
      <!-- Pools -->
      <v-flex xs12 md7 lg8 class="mb-5 pb-4">
        <v-subheader>Pools</v-subheader>
        <v-expansion-panel v-model="pool">
          <v-expansion-panel-content v-for="(pool, indexP) in pools" :key="indexP + 1">
            <template v-slot:header>
              <div>
                {{ pool.name }}
                <br />
                <div style="display: initial">
                  <v-chip
                    small
                    class="mb-0 ml-0"
                    v-for="creditor in creditorsInThisPool(pool.id)"
                    :key="creditor.creditor_id"
                  >
                    {{ creditor.name }}
                  </v-chip>
                </div>
              </div>
            </template>
            <v-card>
              <v-card-text class="pt-0 pb-1">
                <v-layout row wrap>
                  <v-flex xs12 class="pt-0"> </v-flex>
                  <v-flex xs12>
                    <v-text-field
                      box
                      hide-details
                      label="Nome"
                      v-model="pool.name"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 class="my-2">
                    <v-divider />
                  </v-flex>
                  <!--  -->
                  <v-flex xs12 v-for="(broker, indexB) in pool.brokers" :key="indexB + 1">
                    <v-layout row wrap>
                      <v-flex sm7>
                        <v-select
                          box
                          hide-details
                          label="Brokers"
                          item-value="id"
                          item-text="name"
                          :items="getGateways(pool.brokers, broker.gateway_id)"
                          v-model="broker.gateway_id"
                        >
                          <template slot="selection" slot-scope="data">
                            {{ data.item.name }} (R${{
                              data.item.cost | numeral("0,0[.]000")
                            }})
                          </template>
                          <template slot="item" slot-scope="data">
                            {{ data.item.name }} (R${{
                              data.item.cost | numeral("0,0[.]000")
                            }})
                          </template>
                        </v-select>
                      </v-flex>
                      <v-flex sm5 :style="pool.brokers.length > 1 ? 'display: flex' : ''">
                        <v-text-field
                          box
                          hide-details
                          label="Peso"
                          type="number"
                          v-model="broker.weight"
                        ></v-text-field>
                        <v-btn
                          fab
                          small
                          depressed
                          color="primary"
                          class="ml-0 my-auto ml-2"
                          v-if="pool.brokers.length > 1"
                          @click="deleteBroker(pool, indexB)"
                        >
                          <v-icon dark>close</v-icon>
                        </v-btn>
                      </v-flex>
                      <v-flex xs12>
                        <v-slider
                          hide-details
                          v-model="broker.weight"
                          class="ma-0"
                        ></v-slider>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12 v-if="pool.brokers && pool.brokers.length < MAX_BROKERS">
                    <v-btn depressed block class="ma-0" @click="newBroker(pool)">
                      Novo broker
                    </v-btn>
                  </v-flex>
                  <!--  -->
                  <v-flex xs12 class="mt-2">
                    <v-divider />
                  </v-flex>
                  <v-flex xs12 style="display: flex">
                    <v-btn
                      depressed
                      outline
                      color="red"
                      class="ml-0"
                      :disabled="creditorsInThisPool(pool.id).length > 0"
                      @click="deletPool(indexP, pool.id)"
                    >
                      Deletar
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn depressed color="primary" class="mr-0" @click="save(pool)">
                      Salvar</v-btn
                    >
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-flex>
    </v-layout>
    <v-btn color="accent" fixed bottom right fab @click="newPool">
      <v-icon>add</v-icon>
    </v-btn>
  </v-container>
</template>

<script>
import gatewaysService from "@/services/gateways";
import creditorService from "@/services/creditor";

const MAX_BROKERS = 3;

export default {
  data() {
    return {
      MAX_BROKERS,
      pool: null,
      creditor: 0,
      pools: [],
      gateways: [],
      creditos: [],
      brokersTodelete: {},
    };
  },
  created() {
    creditorService.list({ active: true, order: "id" }).then((resp) => {
      this.creditos = [...resp.objects];
    });
    gatewaysService.gateways(["SMS"]).then((resp) => {
      this.gateways = [...resp.objects];
    });
    gatewaysService.list().then((pools) => {
      gatewaysService.listIten().then((poolsItems) => {
        for (let i = 0; i < pools.objects.length; i++) {
          this.pools.push({
            id: pools.objects[i].id,
            name: pools.objects[i].name,
            created_at: pools.objects[i].created_at,
            updated_at: pools.objects[i].updated_at,
            brokers: [],
          });
          let brokers = poolsItems.objects.filter(
            (pi) => pi.gateway_pool_id == this.pools[i].id
          );
          for (let j = 0; j < brokers.length; j++) {
            this.pools[i].brokers.push({
              id: brokers[j].id,
              gateway_id: brokers[j].gateway_id,
              gateway_pool_id: brokers[j].gateway_pool_id,
              weight: brokers[j].weight,
              updated_at: brokers[j].updated_at,
              created_at: brokers[j].created_at,
            });
          }
        }
      });
    });
  },
  computed: {
    poolsValidated() {
      return this.pools.filter((p) => p.id);
    },
  },
  methods: {
    newPool() {
      this.pools.push({
        id: null,
        name: "Pool - " + (this.pools.length + 1),
        brokers: [
          {
            gateway_id: this.gateways[0].id,
            weight: 1,
          },
        ],
      });
      this.pool = this.pools.length - 1;
    },
    deletPool(index, id) {
      if (id) {
        gatewaysService
          .savePool(id, {
            active: false,
          })
          .then(() => {
            this.pools.splice(index, 1);
            this.$store.commit("showSnackbar", "Pool excluida com sucesso!");
          });
      } else this.pools.splice(index, 1);
    },
    newBroker(pool) {
      pool.brokers.push({
        gateway_pool_id: pool.id,
        gateway_id: this.getGateways(pool.brokers)[0].id,
        weight: 1,
      });
    },
    deleteBroker(pool, index) {
      if (!this.brokersTodelete[pool.id]) {
        this.brokersTodelete[pool.id] = [];
      }
      if (pool.brokers[index].id) {
        this.brokersTodelete[pool.id].push(pool.brokers[index]);
      }
      pool.brokers.splice(index, 1);
    },
    activePool(idCreditor, idPool) {
      creditorService
        .update(idCreditor, {
          sms_gateway_pool_id: idPool,
        })
        .then(() => {
          let creditorSelected = this.creditos.find((c) => c.creditor_id == idCreditor);
          creditorSelected.sms_gateway_pool.id = idPool;
          this.$store.commit("showSnackbar", "Pool ativa com sucesso!");
        });
    },
    getGateways(brokers, id = 0) {
      let validGateways = [];
      let gatewaysActive = [];
      this.gateways.forEach((g) => {
        if (g.id == id) {
          validGateways.push(g);
        } else if (brokers.map((b) => b.gateway_id).indexOf(g.id) === -1) {
          validGateways.push(g);
        }
      });
      validGateways.forEach((gateway) => {
        if(gateway.active == 1){
          gatewaysActive.push(gateway);
        }
      });
      return gatewaysActive;
    },
    creditorsInThisPool(id) {
      if (!this.creditos.length) return [];
      let creditors = this.creditos.filter((c) => c.sms_gateway_pool.id == id);
      if (!creditors) return [];
      return creditors;
    },
    save(pool) {
      let text = "Pool criada com sucesso!";
      if (pool.id) {
        text = "Pool salvo com sucesso!";
        gatewaysService.savePool(pool.id, {
          name: pool.name,
        });
        pool.brokers.forEach((broker) => {
          if (broker.id) {
            gatewaysService.saveBroker(broker.id, {
              gateway_id: broker.gateway_id,
              gateway_pool_id: broker.gateway_pool_id,
              weight: broker.weight,
            });
          } else {
            gatewaysService.createBroker(broker).then((newBroker) => {
              broker.created_at = newBroker.created_at;
              broker.id = newBroker.id;
              broker.updated_at = newBroker.updated_at;
            });
          }
        });
        if (this.brokersTodelete[pool.id]) {
          this.brokersTodelete[pool.id].forEach((broker) => {
            gatewaysService.deleteBroker(broker.id);
          });
          delete this.brokersTodelete[pool.id];
        }
      } else {
        gatewaysService
          .createPool({
            name: pool.name,
            active: true,
          })
          .then((newPool) => {
            pool.created_at = newPool.created_at;
            pool.id = newPool.id;
            pool.updated_at = newPool.updated_at;
            pool.brokers.forEach((broker) => {
              broker.gateway_pool_id = newPool.id;
              gatewaysService.createBroker(broker).then((newBroker) => {
                broker.created_at = newBroker.created_at;
                broker.id = newBroker.id;
                broker.updated_at = newBroker.updated_at;
              });
            });
          });
      }
      this.$store.commit("showSnackbar", text);
    },
    exclude() {},
  },
};
</script>

<style>
.qj-brokers-list .v-input__control {
  width: 100%;
}
</style>
